import { render, staticRenderFns } from "./EditarGerencia.vue?vue&type=template&id=74496d18&"
import script from "./EditarGerencia.vue?vue&type=script&lang=js&"
export * from "./EditarGerencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports